import { Module, GetterTree, MutationTree, ActionTree } from "vuex";
import { SOURCE } from "@/modules/foz_chapeco/settings";
import { simulator } from "./simulator";

export interface IFozChapecoState {}

const initialState: IFozChapecoState = {};

const mutations: MutationTree<IFozChapecoState> = {};

const actions: ActionTree<IFozChapecoState, any> = {
    async initialize({ dispatch }) {
        await dispatch("common/initialize", SOURCE, {
            root: true
        });
    }
};

const getters: GetterTree<IFozChapecoState, any> = {
    needInitialize(state, getters, rootState, rootGetters) {
        const needInitializeList = [rootGetters["common/needInitialize"]];
        return needInitializeList.some(item => item);
    }
};

export const fozChapeco: Module<IFozChapecoState, any> = {
    namespaced: true,
    state: initialState,
    mutations,
    actions,
    getters,
    modules: {
        simulator
    }
};
